import Swiper, { Navigation, Mousewheel, FreeMode } from 'swiper'

Swiper.use([Navigation, Mousewheel, FreeMode])

const SELECTORS = {
  storyList: '.js-featured-story-list',
  swiper: '.js-featured-story-list__swiper',
  navNext: '.js-swiper_nav--next',
  navPrev: '.js-swiper_nav--prev'
}

class FeaturedStoryList {
  constructor (element) {
    this.element = element
    this.swiper = this.element.querySelector(SELECTORS.swiper)
    this.navNext = this.element.querySelector(SELECTORS.navNext)
    this.navPrev = this.element.querySelector(SELECTORS.navPrev)
    this.slideshow = null

    this.init()
  }

  init() {
    this.createCarousel()
  }

  createCarousel() {
    this.slideshow = new Swiper(this.swiper, {
      slidesPerView: 1.125,
      centeredSlides: false,
      slidesOffsetAfter: 30,
      spaceBetween: 15,
      a11y: false,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      freeMode: {
        enabled: true,
        sticky: true,
        momentumBounce: false
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 'auto'
        }
      },
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev
      }
    })
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: SELECTORS.storyList,
  Source: FeaturedStoryList
}
